import React from "react";
import RemoteTable from "../../components/ui/RemoteTable";
import { getUnit } from "../../utils/ar";
import { printFullDate } from "../../utils/time";
import { useLanguage } from "../../context/LanguageContext";

const VideoViews = () => {
    const { language } = useLanguage();

    const content = {
        columns: {
            sequence: { en: "Sequence", ar: "التسلسل", de: "Sequenz" },
            videoName: { en: "Video Name", ar: "اسم الفيديو", de: "Videoname" },
            courseName: { en: "Course Name", ar: "اسم الكورس", de: "Kursname" },
            duration: { en: "Watch Duration", ar: "مدة المشاهدة", de: "Sehdauer" },
            watchTime: { en: "Watch Time", ar: "وقت المشاهدة", de: "Uhrzeit" },
            noVideoName: {
                en: "--- Video Name Not Found ---",
                ar: "--- لم يتم العثور علي اسم الفيديو ---",
                de: "--- Videoname nicht gefunden ---",
            },
            noCourseName: {
                en: "--- Course Name Not Found ---",
                ar: "--- لم يتم العثور علي اسم الكورس ---",
                de: "--- Kursname nicht gefunden ---",
            },
            noDuration: {
                en: "-- Video Not Played --",
                ar: "-- لم يتم تشغيل الفيديو --",
                de: "-- Video nicht abgespielt --",
            },
        },
    };
    let columns = [
        {
            name: content.columns.sequence[language],
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: content.columns.videoName[language],
            reorder: true,
            selector: (row) =>
                row.video ? (
                    row.video.name
                ) : (
                    <span className="text-rose-500">{content.columns.noVideoName[language]}</span>
                ),
            sortable: true,
            sortField: "video_id",
        },
        {
            name: content.columns.courseName[language],
            reorder: true,
            selector: (row) =>
                row.course ? (
                    row.course.name
                ) : (
                    <span className="text-rose-500">{content.columns.noCourseName[language]}</span>
                ),
            sortable: true,
            sortField: "course_id",
        },
        {
            name: content.columns.duration[language],
            reorder: true,
            selector: (row) =>
                row.duration_played > 0 ? (
                    (getUnit(
                        Math.ceil(row.duration_played / 60),
                        language === "ar" ? "دقائق" : "minutes",
                        language === "ar" ? "دقيقة" : "minute",
                        language === "ar" ? "دقيقتان" : "2 minutes",
                        true
                    ).value || "") +
                    " " +
                    getUnit(
                        Math.ceil(row.duration_played / 60),
                        language === "ar" ? "دقائق" : "minutes",
                        language === "ar" ? "دقيقة" : "minute",
                        language === "ar" ? "دقيقتان" : "2 minutes",
                        true
                    ).label
                ) : (
                    <span className="text-rose-500">{content.columns.noDuration[language]}</span>
                ),
            sortable: true,
            sortField: "duration_played",
        },
        {
            name: content.columns.watchTime[language],
            reorder: true,
            selector: (row) => printFullDate(row.created_at, language),
            sortable: true,
            sortField: "created_at",
        },
    ];
    return (
        <div>
            <div className="w-full">
                <RemoteTable
                    isAdmin={false}
                    api={`/api/user/video_views/paginate`}
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default VideoViews;
